import { payable } from './invoiceLedger';

export const selectedPayableRows = (rows, selected) =>
  rows.filter((invoice) => selected[invoice._id] && payable(invoice));

export const selectedBalanceTotal = (rows) =>
  Math.round(rows.reduce((total, invoice) => total + Number(invoice.balance || 0), 0) * 100) / 100;

export const canSelectInvoice = (invoice, selected, selectedClinicId) =>
  Boolean(selected[invoice._id]) ||
  (payable(invoice) && (!selectedClinicId || String(invoice.clinic._id) === selectedClinicId));

export const selectionForClinic = (rows, clinicId) =>
  rows.reduce((selection, invoice) => {
    if (payable(invoice) && String(invoice.clinic._id) === clinicId) selection[invoice._id] = true;
    return selection;
  }, {});
